import { store } from "../Store/store";
import {
  updateSortedInventory,
  updateSortedShopping,
  updateSortedTrash,
} from "../Actions/firebaseActions";

export default function orderList(list, order, screen) {
  let objArray = [];

  try {
    Object.keys(list).forEach(function (key) {
      objArray.push(list[key]);
    });

    objArray.sort(function (a, b) {
      var dateA = new Date(a.dates[0]);
      var dateB = new Date(b.dates[0]);
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      var qtyA = a.quantity;
      var qtyB = b.quantity;

      if (order === "name asc") {
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      } else if (order === "name desc") {
        return textA > textB ? -1 : textA < textB ? 1 : 0;
      } else if (order === "EAN") {
        var numA = a.EANcode;
        var numB = b.EANcode;
        return numA < numB ? -1 : numA > numB ? 1 : 0;
      } else if (order === "qty desc") {
        return qtyA < qtyB ? -1 : qtyA > qtyB ? 1 : 0;
      } else if (order === "qty asc") {
        return qtyA > qtyB ? -1 : qtyA < qtyB ? 1 : 0;
      } else if (order === "date oldest") {
        return dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
      } else if (order === "date newest") {
        return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
      } else {
        return null;
      }
    });
  } catch {
    if (screen === "inventory") {
      store.dispatch(updateSortedInventory(list, order));
    } else if (screen === "shopping") {
      store.dispatch(updateSortedShopping(list, order));
    } else if (screen === "trash") {
      store.dispatch(updateSortedTrash(list, order));
    }

    return list;
  }
  if (screen === "inventory") {
    store.dispatch(updateSortedInventory(objArray, order));
  } else if (screen === "shopping") {
    store.dispatch(updateSortedShopping(objArray, order));
  } else if (screen === "trash") {
    store.dispatch(updateSortedTrash(objArray, order));
  }
}
